// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Cz8f0e7","text":"_1nB_nJMb"};